var generics = {
	isSaving: (action) => {
		// console.log('test')
		return {type: action.toUpperCase(), payload: {}};
	}
};

generics.setValue = function (action, key, params) {
	if (arguments.length === 3) {
		console.log(action, key, params);
		return {
			type: action.toUpperCase(),
			payload: {
				[key]: params
			}
		};
	} else if (arguments.length === 2 && typeof key === "object") {
		console.log(action, key);
		return {
			type: action.toUpperCase(),
			payload: key
		};
	} else {
		throw new Error("setValue() only accept arguments as follow setValue(actionType, key, value) or setValue(actionType, {key: value})");
	}
};

module.exports = generics;



// WEBPACK FOOTER //
// ./actions/generics.js